export default __webpack_public_path__ + "static/media/landing-logo.81b24f5e.svg";